export default {"src":"/_next/static/media/share-icon-twitter.59d828c8.svg","height":26,"width":27};